export class NotificationPostModel {
        public  IsReaded:boolean;
        public  ProjectID:number;
}
